const _request = (url, method, body, isJson = false) => {
    const http = new XMLHttpRequest();

    http.open(method, url, true);
    if (isJson) {
        http.setRequestHeader("Content-Type", "application/json");
    }
    http.send(body);

    return new Promise((resolve, reject) => {
        http.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve(http.response);
                } else {
                    reject();
                }
            }
        };
    });
};

const getRandomBorderRadius = () => {
    const values = [];
    for (let index = 0; index < 4; index++) {
        const value = Math.floor(Math.random() * 35) + 35;
        values.push(value);
    }
    return `${values[0]}% ${100 - values[0]}% ${values[1]}% ${100 -
        values[1]}% / ${values[2]}% ${100 - values[3]}% ${values[3]}% ${100 -
        values[2]}%`;
};

const generateBorderRadius = () => {
    document.querySelectorAll(".random-border-radius").forEach((e) => {
        e.style.borderRadius = getRandomBorderRadius();
    });
};

const initFlickityWrapper = (className, options) => {
    document.querySelectorAll(className).forEach((el) => {
        const carousel = el.querySelector(".flickity-carousel");
        const defaultOptions = {
            cellAlign: "left",
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            contain: true,
        };
        const flickity = new Flickity(
            carousel,
            options ? options : defaultOptions
        );

        toggleSliderArrows(flickity, el)

        el.querySelectorAll(".flickity-next").forEach((button) => {
            button.addEventListener("click", () => {
                flickity.next();
            });
        });

        el.querySelectorAll(".flickity-previous").forEach((button) => {
            button.addEventListener("click", () => {
                flickity.previous();
            });
        });

        flickity.on('change', i => {
            toggleSliderArrows(flickity, el)
        });

        el.querySelectorAll(".flickity-viewport").forEach((vp) => {
            vp.style.maxHeight = "476.844px";
        });
    });
};

const toggleSliderArrows = (flickity, el) => {
    el.querySelectorAll(".flickity-next").forEach((button) => {
        if (flickity.selectedCell.target == flickity.getLastCell().target) {
            button.style.display = 'none';
        } else {
            button.style.display = 'block';
        }
    });

    el.querySelectorAll(".flickity-previous").forEach((button) => {
        if (flickity.selectedCell.target == 0) {
            button.style.display = 'none';
        } else {
            button.style.display = 'block';
        }
    });
}

const initWeather = async (className, initialLoad = false) => {
    document.querySelectorAll(className).forEach((el) => {
        if (initialLoad) {
            setWeather(0, el);
        }

        const daySwitch = el.querySelector(".weather-day-selector");
        const menu = el.querySelector(".dropdown-menu");
        daySwitch.addEventListener("click", () => {
            if (menu.classList.contains("show") || daySwitch.classList.contains("show")) {
                menu.classList.remove("show") || daySwitch.classList.remove("show");
            } else {
                menu.classList.add("show") || daySwitch.classList.add("show");
            }
        });

        var today = translatedDays[0];
        var tomorrow = translatedDays[1];
        var days = translatedDays.slice(2);
        let day = new Date().getDay() - 1;

        for (let i = 0; i < 6; i++) {
            const dayEl = el.querySelector(`.day-${i}`);
            const text = i == 0 ? today : i == 1 ? tomorrow : days[day];

            dayEl.addEventListener("click", () => {
                document.querySelector(`.today`).innerHTML = text;
                setWeather(i, el);
            });
            dayEl.innerHTML = text;

            if (day >= 6) {
                dayEl.remove();
                day = 0;
            } else {
                day++;
            }
        }
    });
};

const setWeather = async (day, container) => {
    const data = JSON.parse(
        await _request(`/api/weather/${day}?culture=${currentLanguage}`, "get")
    );

    if (data && data.BusinessHours) {
        container.querySelector(".time-content").innerHTML =
            data.BusinessHours.UserFriendlyText;
    } else {
        container.querySelector(".time-content").innerHTML = "Onbekend";
    }

    if (data && data.Suggestion) {
        if (data.Suggestion.Button) {
            container.querySelector(".tip-button").href =
                data.Suggestion.Button.Url;
            container.querySelector(".tip-button").target =
                data.Suggestion.Button.Target;
            container
                .querySelectorAll(".tip-button-text")
                .forEach((e) => (e.innerHTML = data.Suggestion.Button.Name));
            container.querySelector(".tip").style.display = "block";
            container.querySelector(".tip-button").style.display =
                "inline-block";
        } else {
            container.querySelector(".tip-button").style.display = "none";
        }

        if (data.Suggestion.Title) {
            container.querySelector(".tip-title").innerHTML =
                data.Suggestion.Title;
            container.querySelector(".tip").style.display = "block";
            container.querySelector(".tip-title").style.display = "block";
        } else {
            container.querySelector(".tip-title").style.display = "none";
        }

        if (data.Suggestion.Content) {
            container.querySelector(".tip-content").innerHTML =
                data.Suggestion.Content;
            container.querySelector(".tip").style.display = "block";
            container.querySelector(".tip-content").style.display = "block";
        } else {
            container.querySelector(".tip-content").style.display = "none";
        }
    } else {
        container.querySelector(".tip").style.display = "none";
    }

    container.querySelector(".weather-content").innerHTML =
        data && data.Temperature
            ? '<svg class="icon icon-park icon-weather"><use xlink:href="#icon-weather"></use></svg> ' +
            data.Temperature +
            "°C"
            : "Onbekend";
};

const initFaq = () => {
    document.querySelectorAll(".faq-item").forEach((el) => {
        const btn = el.querySelector(".btn");
        const collapse = el.querySelector(".collapse");

        btn.addEventListener("click", () => {
            if (collapse.classList.contains("collapsed")) {
                collapse.classList.remove("collapsed");
                collapse.classList.add("collapse");
            } else {
                collapse.classList.add("collapsed");
                collapse.classList.remove("collapse");
            }
        });
    });
};

const initNavSearch = () => {
    const elements = document.querySelectorAll(".nav-search-item");
    elements.forEach((el) => {
        const target = el.getAttribute("data-target");
        searchCallbacks.push((e) => {
            let styles = window.getComputedStyle(el);
            if (
                styles.display !== "none" &&
                e.path.indexOf(el) < 0 &&
                e.path.indexOf(document.querySelector(target + " .search-box")) < 0
            ) {
                hideNavSearch(el, target);
                searchCallbacks.forEach(searchCallback => document.body.removeEventListener("click", searchCallback));
            }
        });
        el.addEventListener("click", (e) => {
            e.preventDefault();
            toggleNavSearch(el, target);
        });
    });
};

let searchCallbacks = [];

const toggleNavSearch = (el, target) => {
    const navContainer = document.querySelector(target);

    if (navContainer.classList.contains("show")) {
        // hide
        hideNavSearch(el, target);
        searchCallbacks.forEach(searchCallback => document.body.removeEventListener("click", searchCallback));
    } else {
        const searchIcon = el.querySelector(".icon-search");
        const closeIcon = el.querySelector(".icon-close");
        const body = document.querySelector("body");
        const navbar = document.querySelector("#navbar");
        const scrollTopPos = window.pageYOffset;
        const queryInput = navContainer.querySelector("input[name=query]");

        navContainer.classList.add("show");
        searchIcon.classList.add("collapse");
        closeIcon.classList.remove("collapse");
        body.style.top = -scrollTopPos + "px";
        body.setAttribute("data-scrolltop", scrollTopPos);

        searchCallbacks.forEach(searchCallback => document.body.addEventListener("click", searchCallback));

        navbar.classList.add("search-open");
        body.classList.add("search-open");

        queryInput.focus();
    }
};

const hideNavSearch = (el, target) => {
    if (document.body.classList.contains("search-open")) {
        const searchIcon = el.querySelector(".icon-search");
        const closeIcon = el.querySelector(".icon-close");
        const navContainer = document.querySelector(target);
        const body = document.querySelector("body");
        const oldScrollOffset = body.getAttribute("data-scrolltop");
        const navbar = document.querySelector("#navbar");

        body.classList.remove("search-open");
        navbar.classList.remove("search-open");
        navContainer.classList.remove("show");
        searchIcon.classList.remove("collapse");
        closeIcon.classList.add("collapse");
        body.style.overflow = "";
        window.scrollTo(0, oldScrollOffset);
    }
};

const initNavContainer = () => {
    const elements = document.querySelectorAll(".nav-menu-item");
    elements.forEach((el) => {
        const target = el.getAttribute("data-target");
        const container = document.querySelector(target);
        navCallbacks.push((e) => {
            let styles = window.getComputedStyle(el);
            if (
                styles.display !== "none" &&
                e.path &&
                e.path.indexOf(el) < 0 &&
                e.path.indexOf(document.querySelector(target + " .nav-menu")) < 0
            ) {
                hideNavContainer(container, el);
                navCallbacks.forEach(navCallback => { document.body.removeEventListener("click", navCallback) });
            }
        });
        el.addEventListener("click", (e) => {
            e.preventDefault();
            container
                .querySelectorAll(".nav-main a[data-target]")
                .forEach((link) => {
                    link.addEventListener("mouseenter", (e) => {
                        e.preventDefault();
                        showNavContent(
                            container,
                            link.getAttribute("data-target")
                        );
                    });
                });
            container
                .querySelector(".nav-menu-close")
                .addEventListener("click", () => {
                    hideNavContent(container);
                });
            toggleNavContainer(container, el, target);
        });

    });
};

let navCallbacks = [];
const toggleNavContainer = (container, el, target) => {
    if (container.classList.contains("show")) {
        // hide
        hideNavContainer(container, el);
        navCallbacks.forEach(navCallback => { document.body.removeEventListener("click", navCallback) });
    } else {
        const menuIcon = el.querySelector(".nav-menu-icon-open");
        const closeIcon = el.querySelector(".nav-menu-icon-close");
        const body = document.querySelector("body");
        const navbar = document.querySelector("#navbar");
        const scrollTopPos = window.pageYOffset;

        //Show first sub-items of item on desktop
        if (window.innerWidth > 992) {
            showNavContent(container, container.querySelector(".nav-main a[data-target]").getAttribute("data-target"));
        }

        navbar.classList.add("menu-open");
        body.classList.add("menu-open");
        container.classList.add("show");
        menuIcon.classList.add("collapse");
        closeIcon.classList.remove("collapse");
        body.style.top = -scrollTopPos + "px";
        body.setAttribute("data-scrolltop", scrollTopPos);
        document.querySelectorAll(".menu-nav-open").forEach((e) => {
            e.classList.add("collapse");
        });
        document.querySelectorAll(".menu.nav-close").forEach((e) => {
            e.classList.remove("collapse");
        });

        navCallbacks.forEach(navCallback => { document.body.addEventListener("click", navCallback) });
    }
};

const hideNavContainer = (container, el) => {
    if (document.body.classList.contains("menu-open")) {

        const menuIcon = el.querySelector(".nav-menu-icon-open");
        const closeIcon = el.querySelector(".nav-menu-icon-close");
        const body = document.querySelector("body");
        const navbar = document.querySelector("#navbar");
        body.classList.remove("menu-open");
        navbar.classList.remove("menu-open");

        container.classList.remove("show");
        menuIcon.classList.remove("collapse");
        closeIcon.classList.add("collapse");

        const oldScrollOffset = body.getAttribute("data-scrolltop");
        window.scrollTo(0, oldScrollOffset);
        document.querySelectorAll(".nav-menu-icon-open").forEach((e) => {
            e.classList.remove("collapse");
        });
        document.querySelectorAll(".nav-menu-icon-close").forEach((e) => {
            e.classList.add("collapse");
        });
        body.style.overflow = "";
    }
};

const showNavContent = (main, target) => {
    main.querySelectorAll(".nav-content").forEach((e) => {
        e.classList.remove("show");
    });
    main.querySelector(".nav-sub").classList.add("show");
    const element = main.querySelector(target)
    if (element) {
        element.classList.add("show");
    }
};

const hideNavContent = (main) => {
    main.querySelectorAll(".nav-content").forEach((e) => {
        e.classList.remove("show");
    });
    main.querySelector(".nav-sub").classList.remove("show");
};

const initHeaderVideoButtons = () => {

    var video = document.getElementById("headervideo");

    const playButton = document.getElementById("play-button");
    playButton.addEventListener("click", function () {
        video.play();
        pauseButton.classList.add("d-flex");
        playButton.classList.remove("d-flex");
        playButton.classList.add("d-none");
    });

    const pauseButton = document.getElementById("pause-button");
    pauseButton.addEventListener("click", function () {
        video.pause();
        playButton.classList.add("d-flex");
        pauseButton.classList.remove("d-flex");
        pauseButton.classList.add("d-none");
    });
};

const initHideNavOnScroll = () => {
    let prevScrollpos = window.pageYOffset;
    window.onscroll = function () {
        let currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
            document.getElementById("navbar").style.top = "0";
        } else {
            document.getElementById("navbar").style.top = "-80px";
        }
        prevScrollpos = currentScrollPos;
    };
};

const initCopyToClipboard = () => {
    const elements = document.querySelectorAll("#copy-to-clipboard");
    elements.forEach((el) => {
        el.addEventListener("click", (e) => {
            e.preventDefault();

            const href = el.href;

            if (href) {
                const textArea = document.createElement("textarea");

                textArea.value = href;
                textArea.style.top = "0";
                textArea.style.left = "0";
                textArea.style.position = "fixed";

                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
            }
        });
    });
};

const initSliderItemHoverVideo = () => {
    const elements = document.querySelectorAll(".intro-slider-item.hover-video");
    elements.forEach((el) => {
        if (screen.width > 767) {
            el.addEventListener("mouseenter", (e) => {
                const vid = el.querySelector('video');
                const pic = el.querySelector('picture');

                if (vid && vid.readyState === 4) {
                    vid.currentTime = 0;
                    vid.play();
                    pic.classList.add('hide');
                }
            });
            el.addEventListener("mouseleave", (e) => {
                const pic = el.querySelector('picture');
                pic.classList.remove('hide');
            });
        }
    });
};

const startVideo = () => {
    const homepage = document.getElementById("vue-header");
    const video = document.getElementById("headervideo");
    if (!homepage) {
        if (video) {
            setTimeout(() => {
                if (video.paused && video.readyState > 2) {
                    video.play();
                } else {
                    //vid is already playing so do nothing
                }
            }, 500)
        }
    }
}

const registerPageVisit = () => {
    // get visitor popup
    getVisitorPopup(layoutContent.currentPageId, layoutContent.culture).then((popupData) => {
        if (popupData && popupData.id > 0) {
            var modal = $("#userModal");

            modal.addClass(popupData.ecoDisplay);

            modal.attr("data-modalId", popupData.id);

            var image = modal.find(".modal-image");
            $(image).attr("src", popupData.imageUrl);

            var link = modal.find(".modal-link");
            if (popupData.link != null) {
                if (popupData.link.url) {
                    $(link).attr("href", popupData.link.url);
                }
                if (popupData.link.target && popupData.link.target != null) {
                    $(link).attr("target", popupData.link.url);
                }
            }

            var linktext = link.find(".roll-text");
            $(linktext).html(popupData.link.name);

            var title = modal.find(".modal-title");
            $(title).html(popupData.title);

            var content = modal.find(".modal-content-field");
            $(content).html(popupData.text);

            function onHideModal() {
                var popups = getCookie("userPopups");
                var shownItems = "";

                var clickedItem = popupData.id;
                if (popups != "" && popups != null) {
                    shownItems = popups + "," + clickedItem;
                }
                else {
                    shownItems = clickedItem;
                }

                setCookie("userPopups", shownItems, popupData.duration);
            }

            $(modal).on("hide.bs.modal", onHideModal);
            $('.btn', modal).click(onHideModal);

            // Open modal
            var options = {
                backdrop: false
            }

            $(modal).on("shown.bs.modal", () => {
                document.body.classList.remove("modal-open");
            })

            $(modal).modal(options);
        }
    })
    .catch((err) => {
        console.log('Could not load visitor popup');
    });
}

const setCookie = (name, value, days) => {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
    document.location.reload();
}

const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

const getVisitorPopup = async (id, culture) => {
    var popUpRequest = { pageId: id, culture: culture };
    const data = JSON.parse(await _request("/api/popup/getpopup", "POST", JSON.stringify(popUpRequest), true));
    return data;
}

document.addEventListener("CookiebotOnAccept", function (e) {
    if (Cookiebot.changed) {
        document.location.reload();
    }
});

document.addEventListener("DOMContentLoaded", () => {
    generateBorderRadius();

    $('#loadmoreNews').on('click', function () {
        $(this).addClass('d-none');
        $(this).next().removeClass('d-none');
    })
    $('#loadlessNews').on('click', function () {
        $(this).addClass('d-none');
        $(this).prev().removeClass('d-none');
    })

    $('#renewCookies').on('click', function (e) {
        e.preventDefault();
        Cookiebot.renew();
    });

    const sliders = document.querySelectorAll("[data-slider]");
    sliders.forEach(function (element) {
        const classname = ".slider-" + element.dataset.slider;
        initFlickityWrapper(classname, {
            cellAlign: "left",
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            contain: true,
            lazyLoad: 4
        });
    });

    const modals = $(".modal");
    modals.each(function (element) {
        const currentModal = $(this).attr('id');
        const src = $("#" + currentModal + " iframe").attr("src");
        $(this).on("hidden.bs.modal", function (m) {
            $("#" + currentModal + " iframe").attr("src", "");
        });
        $(this).on("show.bs.modal", function (m) {
            $("#" + currentModal + " iframe").attr("src", src);
        });
    });

    const introSliders = document.querySelectorAll("[data-slider-intro]");
    introSliders.forEach(function (element) {
        const classname = ".slider-" + element.dataset.sliderIntro;
        initFlickityWrapper(classname, {
            cellAlign: "left",
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            contain: true,
            on: {
                ready: function () {
                    if (screen.width <= 991) {
                        const firstSlide = element.querySelector(".slider-item");

                        if (firstSlide && firstSlide.classList.contains('hover-video')) {
                            firstSlide.querySelector('video').play();
                        }
                    }
                },
                change: function (index) {
                    const introWrapper = element.querySelector(".intro");

                    if (index < 1) {
                        introWrapper.classList.remove("hidden");
                    } else {
                        introWrapper.classList.add("hidden");
                    }

                    //Ecodisplays grideditor slider (auto. play video on mobile)
                    if (screen.width <= 991) {
                        const slides = element.querySelectorAll(".slider-item");
                        if (slides && typeof slides[index] !== 'undefined' && slides[index].classList.contains('hover-video')) {
                            slides[index].querySelector('video').currentTime = 0;
                            slides[index].querySelector('video').play();
                        }

                        setTimeout(function () {
                            if (typeof slides[index - 1] !== 'undefined' && slides[index - 1].classList.contains('hover-video'))
                                slides[index - 1].querySelector('video').pause();
                            if (typeof slides[index + 1] !== 'undefined' && slides[index + 1].classList.contains('hover-video'))
                                slides[index + 1].querySelector('video').pause();
                        }, 250);
                    }
                },
            },
        });
    });

    initFaq();
    //initWeather(".weather-block", true);
    initNavSearch();
    initNavContainer();
    initCopyToClipboard();

    initHideNavOnScroll();
    initSliderItemHoverVideo();
    startVideo();

    registerPageVisit();

    //initHeaderVideoButtons();
});
